<template>
  <div class="blog-card">
    <nuxt-link :to="slug" @click.native="collectData">
      <KenticoResponsiveImage :src="imageUrl" :alt="featuredImage.description" class="blog-card__image" :sizes="imageSizes" />
    </nuxt-link>
    <div class="blog-card__meta">
      <p v-if="tag" class="blog-card__meta-item text--xx-small text--faux">{{ tagTitle }}</p>
      <p class="blog-card__meta-item text--xx-small text--faux">{{ formattedDate }}</p>
    </div>
    <p class="blog-card__title">{{ title }}</p>
    <div v-if="excerpt" class="blog-card__preview" v-html="excerpt" />
    <p v-if="author.name" class="blog-card__author">By {{ authorName }}</p>
    <nuxt-link :to="slug" class="btn--dark-green" aria-label="explore-article" @click.native="collectData">
      {{ viewPostText }}
      <Arrow class="btn--arrow__icon btn--arrow__icon--orange" />
    </nuxt-link>
  </div>
</template>

<script>
import Moment from 'moment';
import { BREAKPOINTS, BREAKPOINT_MD, BREAKPOINT_LG } from '~/utils/constants';
import { clickedCta } from '~/utils/gtm-events.js';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    featuredImage: {
      type: Object,
      required: true,
      default() {
        return {
          url: { type: String, required: true },
          description: { type: String, required: true },
        };
      },
    },
    aggregatorImage: {
      type: Object,
      default() {
        return {
          url: { type: String, required: true },
          description: { type: String, required: true },
        };
      },
    },
    tag: {
      type: Object,
      default() {
        return {};
      },
    },
    date: {
      type: String,
      required: true,
    },
    author: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    excerpt: {
      type: String,
      default: '',
      required: true,
    },
    viewPostText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      imageSizes: {
        default: [900, 750],
        sizes: [
          { breakpoint: BREAKPOINTS[BREAKPOINT_MD], width: 900, height: 750 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_LG], width: 900, height: 750 },
        ],
      },
    };
  },
  computed: {
    imageUrl() {
      if (this.aggregatorImage && this.aggregatorImage.url) {
        return this.aggregatorImage.url;
      }

      if (this.featuredImage && this.featuredImage.url) {
        return this.featuredImage.url;
      }

      return null;
    },
    authorName() {
      return this.author.name;
    },
    tagTitle() {
      return this.tag.title;
    },
    formattedDate() {
      if (this.date.length > 0) {
        const momentDate = Moment(this.date);
        return momentDate.format('Do MMM Y');
      }

      return '';
    },
  },
  methods: {
    collectData() {
      clickedCta(this.$gtm, this.viewPostText, null, null, this.slug);
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_blog-card.scss';
</style>
